import React, { FC } from 'react';
import { useNavigate } from 'react-router-dom';

import { Course, TeamGameMatchTeam, UpdateStatus } from '../../../../database.schema';
import { useTournamentTierPointsResultScoreCardMutation } from '../../../api/tournament-data';
import { Button } from '../../common-styles/common-styles';
import { getHoleTierPoints6_6_6, getPlayerStablefordPoints } from '../../../utils/team-games-score-calculator';
import { BACK_NINE_INDEX, FRONT_NINE_INDEX } from '../../../app/constants';

type UpdateButtonProps = {
  course: Course;
  startingHole: number;
  selectedTournamentIndex: number;
  matchIndex: number;
  teamIndex: number;
  recordedMatchTeam: TeamGameMatchTeam;
  setUpdateStatus: (updateStatus: UpdateStatus) => void;
};

export const TeamGameUpdateButton: FC<UpdateButtonProps> = ({ selectedTournamentIndex, matchIndex, course, startingHole, recordedMatchTeam, teamIndex, setUpdateStatus }) => {
  const holeIndexes = startingHole === 1 ? [...FRONT_NINE_INDEX, ...BACK_NINE_INDEX] : [...BACK_NINE_INDEX, ...FRONT_NINE_INDEX];
  const navigate = useNavigate();
  const mutation = useTournamentTierPointsResultScoreCardMutation();

  const saveScorecard = () => {
    const points = holeIndexes.reduce((acc, index) => acc + getHoleTierPoints6_6_6(recordedMatchTeam.players, index, course, startingHole), 0);
    const updatedTeam = { ...recordedMatchTeam, players: getPlayerStablefordPoints(recordedMatchTeam.players, course, startingHole), points };
    const dataToSave = { selectedTournamentIndex, matchIndex, recordedMatchTeam: { ...updatedTeam }, teamIndex };
    if (dataToSave) {
      mutation.mutate(
        { ...dataToSave },
        {
          onSuccess: (data) => {
            navigate(`/team-game-edit-results/${selectedTournamentIndex}/${matchIndex}`);
          },
          onError: (error) => {
            setUpdateStatus({ success: false, error: true });
            console.log('<><><>ERROR<><><><', error);
          },
        },
      );
    }
    navigate(`/team-game-edit-results/${selectedTournamentIndex}/${matchIndex}`);
  };
  return (
    <Button data-testid="save-scorecard" onClick={() => saveScorecard()} disabled={!recordedMatchTeam}>
      Save
    </Button>
  );
};
